import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  BLACKOUT_MONTH_OPTIONS,
  buildDateYmd,
  formatDateWritten,
  getBlackoutDayOptions,
  getBlackoutYearOptions,
  parseDateParts,
} from '../types';

/** Month / day / year dropdowns for a single YYYY-MM-DD value in the rule editor. */
@Component({
  selector: 'blackout-date-dropdown',
  templateUrl: './blackout-date-dropdown.component.html',
  styleUrls: ['./blackout-date-dropdown.component.scss'],
})
export class BlackoutDateDropdownComponent implements OnInit, OnChanges {

  /** Stored date in YYYY-MM-DD, or null when unset. */
  @Input() value: string | null = null;
  /** SEL-016/019 — accessible name prefix for the selects, e.g. "Start date" */
  @Input() ariaLabel = '';
  @Input() disabled = false;
  /** When true, the first option in each dropdown clears that part. */
  @Input() allowEmpty = true;
  @Input() testIdPrefix = 'blackout-date';

  @Output() valueChange = new EventEmitter<string | null>();

  formatDateWritten = formatDateWritten;
  monthOptions = BLACKOUT_MONTH_OPTIONS;
  yearOptions: string[] = [];
  dayOptions: string[] = [];

  selectedYear = '';
  selectedMonth = '';
  selectedDay = '';

  ngOnInit(): void {
    this.yearOptions = getBlackoutYearOptions();
    this.syncFromValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && !changes.value.firstChange) {
      this.syncFromValue();
    }
  }

  private syncFromValue(): void {
    const parts = parseDateParts(this.value);
    this.selectedYear = parts.year;
    this.selectedMonth = parts.month;
    this.selectedDay = parts.day;
    this.refreshDayOptions(false);
  }

  private refreshDayOptions(emitAfterClamp: boolean): void {
    this.dayOptions = getBlackoutDayOptions(this.selectedYear, this.selectedMonth);
    if (this.selectedDay && !this.dayOptions.includes(this.selectedDay)) {
      this.selectedDay = this.dayOptions[this.dayOptions.length - 1] || '';
      if (emitAfterClamp) this.emitValue();
    }
  }

  onPartChange(): void {
    this.refreshDayOptions(true);
    if (!this.selectedYear && !this.selectedMonth && !this.selectedDay) {
      this.valueChange.emit(null);
      return;
    }
    this.emitValue();
  }

  private emitValue(): void {
    this.valueChange.emit(buildDateYmd(this.selectedYear, this.selectedMonth, this.selectedDay));
  }
}
